import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const ctasCarousels = document.querySelectorAll('.cta-carousel');
  const breakpoint = window.matchMedia('(min-width: 980px)');

  const swiperRegistry = [];

  const initSwipers = () => {
    ctasCarousels.forEach((carousel, index) => {
      if (swiperRegistry[index]) return;

      const instance = new Swiper(carousel, {
        draggable: true,
        loop: false,
        spaceBetween: 20,
        rewind: true,
        autoHeight: true,
        breakpoints: {
          980: { slidesPerView: 1.05 },
          1280: { slidesPerView: 1.1 },
          1440: { slidesPerView: 1.25 },
        },
        a11y: {
          paginationBulletMessage: "Aller à l'appel à l'action {{index}}",
          nextSlideMessage: "Prochain appel à l'action",
          prevSlideMessage: "Appel à l'action précédent",
        },
        navigation: {
          nextEl: carousel
            .closest('.cta-block')
            ?.querySelector('.cta-carousel__navigation .swiper-button-next'),
          prevEl: carousel
            .closest('.cta-block')
            ?.querySelector('.cta-carousel__navigation .swiper-button-prev'),
        },
      });

      swiperRegistry[index] = instance;
    });
  };

  const destroySwipers = () => {
    swiperRegistry.forEach((instance, index) => {
      if (instance) {
        instance.destroy(true, true);
        swiperRegistry[index] = null;
      }
    });
  };

  const breakpointChecker = function () {
    if (breakpoint.matches) {
      if (ctasCarousels.length > 0) {
        initSwipers();
      }
    } else {
      destroySwipers();
    }
  };

  breakpoint.addEventListener('change', breakpointChecker);
  breakpointChecker();
});
